import { useRef, useEffect } from 'react';
// import prepareTranslate from '@/helpers/dictionary';
import PropTypes from 'prop-types';
import SignatureCanvas from 'react-signature-canvas';
import { IconTrash } from '@tabler/icons-react';
import { Button } from '@mantine/core';
import classes from './signature.module.css';

const Signature = ({
  required,
  onChange,
  label,
  disabled,
  error,
  test,
  isFocused = false,
  value,
}) => {
  const doodleRef = useRef(null);
  const canvasRef = useRef(null);

  // Auto scroll into view
  useEffect(() => {
    if (isFocused && doodleRef.current) {
      doodleRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [isFocused]);

  // Set the signature from value
  useEffect(() => {
    if (value && canvasRef.current && canvasRef.current.isEmpty()) {
      canvasRef.current.fromDataURL(value);
    }
  }, [value]);

  const handleClear = () => {
    canvasRef.current.clear();
    onChange?.('');
  };

  const handleDoodle = () => {
    if (!canvasRef.current.isEmpty()) {
      const urlData = canvasRef.current.toDataURL();
      onChange?.(urlData);
    }
  };

  return (
    <>
      <p className={required ? classes.fieldRequire : ''}>{label}</p>
      <div ref={doodleRef} className={classes.doodleContainer} data-f={test}>
        <SignatureCanvas
          ref={canvasRef}
          canvasProps={{
            className: `${classes.signatureCanvas} ${disabled ? classes.disabledCanvas : ''}`,
          }}
          onEnd={handleDoodle}
          clearOnResize={false}
        />
        {error && <span className={classes.error}>{error}</span>}
        <Button
          variant="transparent"
          data-f='clean button'
          type="button"
          className={classes.clearButton}
          onClick={handleClear}
        >
          <IconTrash />
        </Button>
      </div>
    </>
  );
};

Signature.propTypes = {
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  test: PropTypes.string,
  isFocused: PropTypes.bool,
};

export default Signature;
